import {images} from '../../../common/components/images';

export const devActiveGroupPrograms =
    [
        {
            "id": 55,
            "title": "Supporting The Growth Of Entrepreneurs",
            "description": "<p>Women are the new face of entrepreneurship and are starting businesses in droves&mdash;1,821 net new each day.&nbsp; To support women entrepreneurs and business owners in this environment, we'll share data-driven insights and proven frameworks on:</p><ul><li>What you need to know about female entrepreneurship today</li><li>How you can help her to be successful while she navigates the ups and downs of her entrepreneurial journey (e.g., traditional entrepreneurship, solopreneurship or sidepreneuship)</li><li>Potential funding sources and benefits you can help her uncover</li><li>How to retain her and her assets and grow your relationship</li></ul>",
            "imageUrl": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1649877747/plwp4biwfwgu5xmt9hhi.png",
            "isActive": true,
            "isAssetManagement": true,
            "isPromotionalProgram": true,
            "numberOfLectures": 1,
            "startsOn": null,
            "expectedEnd": null,
            "endedOn": null,
            "price": 15000,
            "author": {
                "id": 4250,
                "wmcId": null,
                "first_name": "Cathy",
                "last_name": "Alessandra",
                "firstName": "Cathy",
                "lastName": "Alessandra",
                "phone": null,
                "email": "cathy@cathyalessandra.com",
                "photo": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1654195520/emwwabghsifuhek0c04t.jpg"
            },
            "ceCredits": 1,
            "industry": null,
            "designationInsitution": null,
            "lectures": [],
            "courses": []
        },
        {
            "id": 56,
            "title": "Engaging NextGen Investors",
            "description": "<p>The market for investing is changing rapidly and tomorrow's clients will look very different than today's. By 2030, Millennials will hold 5x as much wealth as they do today, while Gen Z's income is projected to be $33 trillion (27% of global income). Just as changes in the market require a new approach to investing, changes in demographics require a new approach to attracting and retaining clients. To help you engage the next generation of prospects and heirs, we'll share data-driven insights and proven frameworks on:</p><ul><li>What is most important to Gen Z and Millennial investors compared to other generations</li><li>How Gen Z's goals and investing behaviors differ from Millennials</li><li>How technology and digitalization has shaped NextGen's desire for hyper-personalized, continuous advice, as well as their overall user experience expectations</li><li>How you can better attract&nbsp;</li></ul>",
            "imageUrl": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1649877841/ggnn1mx3ozvoc5iwakiv.png",
            "isActive": true,
            "isAssetManagement": true,
            "isPromotionalProgram": true,
            "numberOfLectures": 1,
            "startsOn": null,
            "expectedEnd": null,
            "endedOn": null,
            "price": 15000,
            "author": {
                "id": 4231,
                "wmcId": null,
                "first_name": "Diana",
                "last_name": "Yanez, CFP\u00ae",
                "firstName": "Diana",
                "lastName": "Yanez, CFP\u00ae",
                "phone": null,
                "email": "diana@allthecolors.net",
                "photo": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1654094101/njcy3eh4lmf52pugdz2v.jpg"
            },
            "ceCredits": 1,
            "industry": null,
            "designationInsitution": null,
            "lectures": [],
            "courses": []
        },
        {
            "id": 53,
            "title": "Supporting Widowed Clients",
            "description": "<p>The number of widows is growing, and the pandemic has changed the way we grieve and move forward. To support widows and grieving clients in this environment, we'll share new insights and actionable ideas, including:</p><p>&nbsp;</p><ul><li>What you need to know about grief today</li><li>Key indicators of where clients are in their grieving and ways you can offer support and understanding</li><li>Your approach and words have impact: how to connect with authenticity and empathy</li><li>How to retain clients and deepen relationships during turbulent times</li></ul>",
            "imageUrl": "https://docs.trustwillow.com/AdobeStock_314853358.webp",
            "isActive": true,
            "isAssetManagement": true,
            "isPromotionalProgram": true,
            "numberOfLectures": 1,
            "startsOn": null,
            "expectedEnd": null,
            "endedOn": null,
            "price": 15000,
            "author": {
                "id": 40,
                "wmcId": null,
                "first_name": "Candice",
                "last_name": "McGarvey, CFP\u00ae",
                "firstName": "Candice",
                "lastName": "McGarvey, CFP\u00ae",
                "phone": 7034028610,
                "email": "candice@herdollars.com",
                "photo": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1696006180/yiv8au1jsgqf6ugqddxi.png"
            },
            "ceCredits": 1,
            "industry": null,
            "designationInsitution": null,
            "lectures": [],
            "courses": []
        },
        {
            "id": 54,
            "title": "Helping Your Clients Navigate Divorce",
            "description": "<p>Although divorce rates have been decreasing over the past few years, &ldquo;grey divorce&rdquo; amongst Baby Boomers is on the rise. In fact, since the 90s, the divorce rate for Americans over 50 has nearly doubled*. So what does this mean for you and your clients? In our group session, we&rsquo;ll discuss what you need to know about supporting divorcing clients today. Why female divorcing clients don't always approach their financial advisors and a framework to address this and strategies to attract new and retain existing divorcing clients with a specialized approach.&nbsp;</p>",
            "imageUrl": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1649877667/byh6ihoqmc4qnfv2gcwh.png",
            "isActive": true,
            "isAssetManagement": true,
            "isPromotionalProgram": true,
            "numberOfLectures": 1,
            "startsOn": null,
            "expectedEnd": null,
            "endedOn": null,
            "price": 15000,
            "author": {
                "id": 37,
                "wmcId": null,
                "first_name": "Allison",
                "last_name": "Bishop, CPA, CDFA\u00ae",
                "firstName": "Allison",
                "lastName": "Bishop, CPA, CDFA\u00ae",
                "phone": 2078058400,
                "email": "allison@allisonbishop.com",
                "photo": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1617399212/tdps392zkczs5lgkgltv.png"
            },
            "ceCredits": 1,
            "industry": null,
            "designationInsitution": null,
            "lectures": [],
            "courses": []
        },
        {
            "id": 61,
            "title": "Navigating Sensitive Client Situations",
            "description": "<p>Examine some of the most common sensitive client situations that trigger emotional or negative responses that may hinder your client relationships. Learn various techniques to help you navigate and diffuse sensitive situations and build trust with your clients.</p>\r\n<p><br></p>\r\n<p>Learning Objectives:</p>\r\n<ol>\r\n  <li>Understand the different types of sensitive client situations and what role you play in them as an advisor.</li>\r\n  <li>Examine some of the most common sensitive client situations and identify their key indicators.</li>\r\n  <li>Learn various communication, mediation, and de-escalation techniques to help you navigate sensitive situations and build trust with your clients.</li>\r\n</ol>",
            "imageUrl": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1655355967/rd40ijma5maezkdhkcoq.png",
            "isActive": true,
            "isAssetManagement": true,
            "isPromotionalProgram": true,
            "numberOfLectures": 1,
            "startsOn": null,
            "expectedEnd": null,
            "endedOn": null,
            "price": 15000,
            "author": {
                "id": 40,
                "wmcId": null,
                "first_name": "Candice",
                "last_name": "McGarvey, CFP\u00ae",
                "firstName": "Candice",
                "lastName": "McGarvey, CFP\u00ae",
                "phone": 7034028610,
                "email": "candice@herdollars.com",
                "photo": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1696006180/yiv8au1jsgqf6ugqddxi.png"
            },
            "ceCredits": 1,
            "industry": null,
            "designationInsitution": null,
            "lectures": [],
            "courses": []
        },
        {
            "id": 67,
            "title": "Planning for Education Expenses",
            "description": "<p>\r\n    Saving for children\u2019s education is a priority for many parents. Financial\r\n    advisers can provide particular expertise in helping their clients\r\n    strategize ways to save for their children\u2019s education while not taking\r\n    their focus off saving for retirement. Learn best practices for how to help\r\n    your clients create a plan for college savings that is integrated into\r\n    their overall financial plan.\r\n</p>\r\n<p><br/></p>\r\n<p>\r\n    Learning Objectives:\r\n</p>\r\n<ol>\r\n    <li>\r\n            Identify the various options available to your clients for\r\n            education savings plans.\r\n    </li>\r\n    <li>\r\n            Explain why it is important that saving for education expenses is\r\n            integrated into the client\u2019s overarching financial plan.\r\n        </p>\r\n    </li>\r\n    <li>\r\n            Learn how to communicate to your clients the benefits and tradeoffs\r\n            of funding college for their kids, and help them determine how much\r\n            they should contribute.\r\n        </p>\r\n    </li>\r\n</ol>",
            "imageUrl": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1655356930/f4bayqhctqiyt1mkrdd6.jpg",
            "isActive": true,
            "isAssetManagement": true,
            "isPromotionalProgram": true,
            "numberOfLectures": 1,
            "startsOn": null,
            "expectedEnd": null,
            "endedOn": null,
            "price": 15000,
            "author": {
                "id": 71,
                "wmcId": null,
                "first_name": "Megan",
                "last_name": "Scipione, CFA",
                "firstName": "Megan",
                "lastName": "Scipione, CFA",
                "phone": 6177634084,
                "email": "megan.scipione@outlook.com",
                "photo": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1604365307/frfaoi99ihoeugsqx96l.png"
            },
            "ceCredits": 1,
            "industry": null,
            "designationInsitution": null,
            "lectures": [],
            "courses": []
        },
        {
            "id": 68,
            "title": "Caring for Aging Parents",
            "description": "<p>\r\n    Caring for aging relatives can be emotional and exhausting. Learn how you\r\n    can help support your clients as they navigate caring for and managing\r\n    finances for their aging parents and/or relatives.\r\n</p>\r\n<p><br/></p>\r\n\r\n<p>    Learning Objectives:\r\n</p>\r\n<ol>\r\n    <li>\r\n            Learn the legal and ethical boundaries of financial caregiving.\r\n    </li>\r\n    <li>\r\n            Understand the unique challenges clients with aging parents face as\r\n            their loved ones\u2019 financial decision-making abilities begin to\r\n            decline.\r\n    </li>\r\n    <li>\r\n            Identify ways in which you can help your clients with aging parents\r\n            get the support they need, such as protection against fraud and\r\n            financial scams.\r\n    </li>\r\n    <li>\r\n            Learn the signs that may indicate your clients\u2019 aging parents need\r\n            financial caregiving.\r\n    </li>\r\n</ol>",
            "imageUrl": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1655357002/q6ojl6emzu6meqoh2swi.png",
            "isActive": true,
            "isAssetManagement": true,
            "isPromotionalProgram": true,
            "numberOfLectures": 1,
            "startsOn": null,
            "expectedEnd": null,
            "endedOn": null,
            "price": 15000,
            "author": {
                "id": 1784,
                "wmcId": null,
                "first_name": "Paula",
                "last_name": "Birmingham",
                "firstName": "Paula",
                "lastName": "Birmingham",
                "phone": 2074509176,
                "email": "paula.j.birmingham@gmail.com",
                "photo": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1609792334/h1roiduuvr4djqxj5hcz.jpg"
            },
            "ceCredits": 1,
            "industry": null,
            "designationInsitution": null,
            "lectures": [],
            "courses": []
        },
        {
            "id": 62,
            "title": "Integrating Coaching into your Practice",
            "description": "<p>\r\n    The emerging discipline of Financial Life Coaching helps clients feel more\r\n    confident, prepared, and valued, empowering them to make confident\r\n    financial decisions. Learn how you can level up your craft by integrating\r\n    coaching into your practice.\r\n</p>\r\n<p><br/></p>\r\n<p dir=\"ltr\">\r\n    Learning objectives:\r\n</p>\r\n<ol>\r\n    <li>\r\n            Learn the benefits of integrating coaching into financial planning\r\n            for your clients.\r\n    </li>\r\n    <li>\r\n            Explore common coaching methods that advisors can use to better\r\n            visualize and comprehend client goals.\r\n    </li>\r\n    <li>\r\n            Demonstrate ways in which you can diversify your team by\r\n            integrating coaching into your practice.\r\n    </li>\r\n</ol>",
            "imageUrl": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1655356420/yprhxvf2kshf0dei2hre.jpg",
            "isActive": true,
            "isAssetManagement": true,
            "isPromotionalProgram": true,
            "numberOfLectures": 1,
            "startsOn": null,
            "expectedEnd": null,
            "endedOn": null,
            "price": 15000,
            "author": {
                "id": 40,
                "wmcId": null,
                "first_name": "Candice",
                "last_name": "McGarvey, CFP\u00ae",
                "firstName": "Candice",
                "lastName": "McGarvey, CFP\u00ae",
                "phone": 7034028610,
                "email": "candice@herdollars.com",
                "photo": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1696006180/yiv8au1jsgqf6ugqddxi.png"
            },
            "ceCredits": 1,
            "industry": null,
            "designationInsitution": null,
            "lectures": [],
            "courses": []
        },
        {
            "id": 69,
            "title": "Supporting Clients Navigating Career Transitions",
            "description": "<p>\r\nEmployment is no longer the stable career path it was especially in the corporate world. Jobs in almost all industries are becoming increasingly commoditized. They are being most affected by globalization and technology.\r\n</p>\r\n<p><br/></p>\r\n\r\n<p> Learning Objectives:\r\n</p>\r\n<ol>\r\n<li>\r\nThe state of the job market and what the future holds.\r\n</li>\r\n<li>\r\nUnderstand the widespread impact of career transitions on clients and their families.\r\n</li>\r\n<li>\r\nHelp clients support their lifestyle during career transitions.\r\n</li>\r\n<li>\r\nDevelop strategies for clients to build a more resilient career path.\r\n</li>\r\n</ol>",
            "imageUrl": "https://docs.trustwillow.com/Career_Transitions_Image.png",
            "isActive": true,
            "isAssetManagement": true,
            "isPromotionalProgram": true,
            "numberOfLectures": 1,
            "startsOn": null,
            "expectedEnd": null,
            "endedOn": null,
            "price": 15000,
            "author": {
                "id": 4567,
                "wmcId": null,
                "first_name": "John",
                "last_name": "Morgan, MBA, CFP\u00ae, CRPC\u00ae",
                "firstName": "John",
                "lastName": "Morgan, MBA, CFP\u00ae, CRPC\u00ae",
                "phone": null,
                "email": "jmorgan1.mcm@gmail.com",
                "photo": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1667849983/akit53w1h7t0zufwh3bv.png"
            },
            "ceCredits": null,
            "industry": null,
            "designationInsitution": null,
            "lectures": [],
            "courses": []
        },
        {
            "id": 65,
            "title": "Engaging Investors in the LGBTQ+ Community",
            "description": "<p>\r\n    Individuals in the LGBTQI+ community have unique financial needs that are\r\n    often overlooked by financial professionals. Learn best practices for how\r\n    you can create an inclusive and safe space for LGBTQ+ investors to get the\r\n    support they need to plan for their future while living authentically\r\n    today.\r\n</p>\r\n<p><br/></p>\r\n<p>\r\n    Learning Objectives:\r\n</p>\r\n<ol>\r\n    <li>\r\n            Demonstrate your understanding of the uniqueness of your LGBTQ+\r\n            clients\u2019 situations and highlight how their financial planning is\r\n            different as a result.\r\n    </li>\r\n    <li>\r\n            Identify ways to add inclusive aspects into your firm in order to\r\n            create a safe space for your LGBTQ+ clients.\r\n    </li>\r\n    <li>\r\n            Learn how to help LGBTQ+ clients create a financial plan that will\r\n            enable them to reach significant personal milestones such as gender\r\n            affirmation surgery, getting married, starting a family, and more.\r\n    </li>\r\n</ol>",
            "imageUrl": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1655356784/xt8j6cjkyb5ee4foqrsb.png",
            "isActive": true,
            "isAssetManagement": true,
            "isPromotionalProgram": true,
            "numberOfLectures": 1,
            "startsOn": null,
            "expectedEnd": null,
            "endedOn": null,
            "price": 0,
            "author": {
                "id": 40,
                "wmcId": null,
                "first_name": "Candice",
                "last_name": "McGarvey, CFP\u00ae",
                "firstName": "Candice",
                "lastName": "McGarvey, CFP\u00ae",
                "phone": 7034028610,
                "email": "candice@herdollars.com",
                "photo": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1696006180/yiv8au1jsgqf6ugqddxi.png"
            },
            "ceCredits": 1,
            "industry": null,
            "designationInsitution": null,
            "lectures": [],
            "courses": []
        },
        {
            "id": 63,
            "title": "Supporting Clients Navigating the Cost of Conception and Adoption",
            "description": "<p>\r\n                        Whether your clients are planning for a baby or already\r\n                        have children, the cost of raising kids is higher than\r\n                        ever. One in eight couples struggle with infertility,\r\n                        and a third (33%) of U.S. adults say they have used\r\n                        fertility treatments or know someone who has. The\r\n                        fertility journey is exhausting and expensive, costing\r\n                        as much as $30,000 to $60,000 or significantly more\r\n                        depending on the number of cycles. Learn best practices\r\n                        for how you can help your clients navigate the costs of\r\n                        conception and adoption.\r\n                    </p>\r\n                    <p><br/></p>\r\n\r\n                    <p>\r\n                        Learning objectives:\r\n                    </p>\r\n                    <ol>\r\n                        <li>\r\n                                Understand the various costs of\r\n                                fertility/adoption and identify the aspects of\r\n                                fertility treatment that policies might cover.\r\n                        </li>\r\n                        <li>\r\n                                Learn what support services are available and\r\n                                how they may be able to help your clients with\r\n                                IVF.\r\n                        </li>\r\n                        <li>\r\n                                Demonstrate the role you play as an advisor in\r\n                                helping clients create a financial plan for\r\n                                fertility treatments.\r\n                        </li>\r\n                        <li>\r\n                                Learn techniques to navigate complex\r\n                                conversations around fertility, communicate\r\n                                with empathy, and build trust with your clients\r\n                                during this emotional time.\r\n                        </li>\r\n                    </ol>",
            "imageUrl": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1655356581/lgpsghwwi3v7c0jfw5py.png",
            "isActive": true,
            "isAssetManagement": true,
            "isPromotionalProgram": true,
            "numberOfLectures": 1,
            "startsOn": null,
            "expectedEnd": null,
            "endedOn": null,
            "price": 15000,
            "author": {
                "id": 4044,
                "wmcId": null,
                "first_name": "Sherry",
                "last_name": "Jordan, CPA, CVA, CFF",
                "firstName": "Sherry",
                "lastName": "Jordan, CPA, CVA, CFF",
                "phone": null,
                "email": "sherry@jordan-financial.com",
                "photo": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1649958934/soktxjza43bu2ccnq2eh.jpg"
            },
            "ceCredits": 1,
            "industry": null,
            "designationInsitution": null,
            "lectures": [],
            "courses": []
        },
        {
            "id": 64,
            "title": "Empowering Women Investors",
            "description": "<p>\r\n    Barron's calls women \"the new face of wealth and investing\" and they're\r\n    right - women are the single greatest opportunity for financial services,\r\n    representing nearly $30T in investable assets by the end of this decade.\r\n    Yet a recent Fidelity study finds that only 33% of women say they feel\r\n    confident making investment decisions. The ability to engage and grow\r\n    trusted relationships with women investors will be a key differentiator in\r\n    growing a successful practice moving forward.\r\n</p>\r\n<p><br/></p>\r\n<p>\r\n    Learning Objectives:\r\n</p>\r\n<ol>\r\n    <li>\r\n            Examine key data and insights on the growing power and wealth of\r\n            women.\r\n    </li>\r\n    <li>\r\n            Learn about what women are uniquely looking for when it comes to\r\n            their relationship with money and their advisor.\r\n    </li>\r\n    <li>\r\n            Explore common personas of women investors and demonstrate how to\r\n            strengthen your relationships with each of them to help grow your\r\n            practice.\r\n    </li>\r\n</ol>",
            "imageUrl": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1655356706/s5a1hwitfx4fjg2ultwx.jpg",
            "isActive": true,
            "isAssetManagement": true,
            "isPromotionalProgram": true,
            "numberOfLectures": 1,
            "startsOn": null,
            "expectedEnd": null,
            "endedOn": null,
            "price": 15000,
            "author": {
                "id": 40,
                "wmcId": null,
                "first_name": "Candice",
                "last_name": "McGarvey, CFP\u00ae",
                "firstName": "Candice",
                "lastName": "McGarvey, CFP\u00ae",
                "phone": 7034028610,
                "email": "candice@herdollars.com",
                "photo": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1696006180/yiv8au1jsgqf6ugqddxi.png"
            },
            "ceCredits": 1,
            "industry": null,
            "designationInsitution": null,
            "lectures": [],
            "courses": []
        },
        {
            "id": 77,
            "title": "Empowering Women Investors 201",
            "description": "<p><span style=\"font-size: 11pt;font-family: Arial;\">This intermediate-level seminar goes deeper into the application of best practices for attracting and serving Millennial and Generation Z clients. </span></p>\r\n<p><span style=\"font-size: 11pt;font-family: Arial;\">1. How to most effectively communicate with and attract prospects online </span></p>\r\n<p><span style=\"font-size: 11pt;font-family: Arial;\">2. Understanding tech needs, wants and available service solutions  </span></p>\r\n<p><span style=\"font-size: 11pt;font-family: Arial;\">3. How to deepen your relationships with NextGens</span></p>",
            "imageUrl": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1701973630/gqbockjm9rfdn01wgj50.jpg",
            "isActive": true,
            "isAssetManagement": true,
            "isPromotionalProgram": true,
            "numberOfLectures": 1,
            "startsOn": null,
            "expectedEnd": null,
            "endedOn": null,
            "price": 0,
            "author": {
                "id": 5077,
                "wmcId": 4,
                "first_name": "Alana",
                "last_name": "Santarelli",
                "firstName": "Alana",
                "lastName": "Santarelli",
                "phone": null,
                "email": "alana+demo@trustwillow.com",
                "photo": "https://res.cloudinary.com/blz-lilyriche/image/upload/yb3esjcmdyfstf4udqpv.jpg"
            },
            "ceCredits": 2,
            "industry": null,
            "designationInsitution": null,
            "lectures": [],
            "courses": []
        },
        {
            "id": 75,
            "title": "Engaging NextGen Investors 201",
            "description": "<p><span style=\"font-size: 11pt;font-family: Arial;\">This intermediate-level seminar goes deeper into the application of best practices for attracting and serving Millennial and Generation Z clients. </span></p>\r\n<p><span style=\"font-size: 11pt;font-family: Arial;\">1. How to most effectively communicate with and attract prospects online </span></p>\r\n<p><span style=\"font-size: 11pt;font-family: Arial;\">2. Understanding tech needs, wants and available service solutions  </span></p>\r\n<p><span style=\"font-size: 11pt;font-family: Arial;\">3. How to deepen your relationships with NextGens</span></p>",
            "imageUrl": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1701973630/gqbockjm9rfdn01wgj50.jpg",
            "isActive": true,
            "isAssetManagement": true,
            "isPromotionalProgram": true,
            "numberOfLectures": 1,
            "startsOn": null,
            "expectedEnd": null,
            "endedOn": null,
            "price": 0,
            "author": {
                "id": 5077,
                "wmcId": 4,
                "first_name": "Alana",
                "last_name": "Santarelli",
                "firstName": "Alana",
                "lastName": "Santarelli",
                "phone": null,
                "email": "alana+demo@trustwillow.com",
                "photo": "https://res.cloudinary.com/blz-lilyriche/image/upload/yb3esjcmdyfstf4udqpv.jpg"
            },
            "ceCredits": 2,
            "industry": null,
            "designationInsitution": null,
            "lectures": [],
            "courses": []
        },
        {
            "id": 74,
            "title": "Engaging Asian American/ AAPI Investors",
            "description": "<p><span style=\"font-size: 11pt;font-family: Arial;\">The phrase \"Asian American\" is problematic because it includes descendants of more than 50 countries and a wide range of cultures. Explore the various communities included within this growing segment of the U.S. population and learn some key ideas to help you build relationships.</span></p>\r\n<p><span style=\"font-size: 11pt;font-family: Arial;\">1. Understand the various cultures represented in the \u201cAsian community\u201d as defined by the United States </span></p>\r\n<p><span style=\"font-size: 11pt;font-family: Arial;\">2. Learn ways to incorporate inclusion into your advisory practice to help you attract, retain, and build more authentic relationships with Asian clients. </span></p>\r\n<p><span style=\"font-size: 11pt;font-family: Arial;\">3. Identify the financial goals of the community and the best way to fulfill their needs.</span></p>",
            "imageUrl": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1701974321/bghtridwwkmg3ge5noax.png",
            "isActive": true,
            "isAssetManagement": true,
            "isPromotionalProgram": true,
            "numberOfLectures": 1,
            "startsOn": null,
            "expectedEnd": null,
            "endedOn": null,
            "price": 0,
            "author": {
                "id": 4854,
                "wmcId": null,
                "first_name": "Christine",
                "last_name": "Sarno",
                "firstName": "Christine",
                "lastName": "Sarno",
                "phone": 3103867388,
                "email": "christinejoylucksarno@gmail.com",
                "photo": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1684861125/jbn0ulvp4mhamp9oqhys.png"
            },
            "ceCredits": 1,
            "industry": null,
            "designationInsitution": null,
            "lectures": [],
            "courses": []
        },
        {
            "id": 73,
            "title": "Helping Clients Build Legacy Through Philanthropy",
            "description": "<p><span style=\"font-size: 11pt;font-family: Arial;\">Incorporating charitable giving is an integral part of a holistic approach to financial planning - both for your clients and your own practice. In addition to the tax benefits of philanthropic activities, pursuing these avenues can pay big dividends for your clients and your firm.  With the increasing need for intergenerational planning and engagement, conversations must be had at all levels of the family. According to Cerulli, more than 70% of heirs are likely to fire or change financial advisors after inheriting their parents\u2019 wealth. However, with 33% of overall heirs and 42% of millennial heirs indicating that they are more likely to stay with their benefactor\u2019s advisor if he or she has helped with family philanthropy, incorporating charitable giving becomes an invaluable opportunity for advisors to build lasting relationships with clients\u2019 heirs and the younger generations.</span></p>\r\n<p><span style=\"font-size: 11pt;font-family: Arial;\">1. Explore trends in intergenerational wealth transfers to understand their impact on the overall wealth management landscape.  </span></p>\r\n<p><span style=\"font-size: 11pt;font-family: Arial;\">2. Identify best practices for integrating charitable giving into intergenerational planning for your clients. </span></p>\r\n<p><span style=\"font-size: 11pt;font-family: Arial;\">3. Demonstrate how you can strengthen relationships with clients and their heirs by incorporating philanthropic activities into your practice.</span></p>\r\n<p></p>",
            "imageUrl": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1701973742/nosjkzudc6unmtudet2p.jpg",
            "isActive": true,
            "isAssetManagement": true,
            "isPromotionalProgram": true,
            "numberOfLectures": 1,
            "startsOn": null,
            "expectedEnd": null,
            "endedOn": null,
            "price": 0,
            "author": {
                "id": 4165,
                "wmcId": null,
                "first_name": "Debra",
                "last_name": "Ohstrom",
                "firstName": "Debra",
                "lastName": "Ohstrom",
                "phone": null,
                "email": "dohstrom@gmail.com",
                "photo": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1653309142/re4rzeeehlxfb7f8xrxg.png"
            },
            "ceCredits": 1,
            "industry": null,
            "designationInsitution": null,
            "lectures": [],
            "courses": []
        },
        {
            "id": 72,
            "title": "Engaging Hispanic - Latine Investors",
            "description": "<p>Growth of the affluent segment within the Latine community is among the fastest in the United States. In fact, if Latines living in the United States were an independent country, their GDP would be the eighth largest GDP in the world. Learn more about the impact of the values and goals of this community plus insight on ways to develop and deepen relationships with Latines.&nbsp;</p>\r\n<ol>\r\n<li>Understanding Hispanic-Latine demographics &amp; wealth today&nbsp;</li>\r\n<li>Learning about unique investor priorities</li>\r\n<li>How to earn new clients in the Hispanic-Latine community</li>\r\n</ol>",
            "imageUrl": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1701973763/dxlwf6lz8hwm83zxlme4.jpg",
            "isActive": true,
            "isAssetManagement": true,
            "isPromotionalProgram": true,
            "numberOfLectures": 1,
            "startsOn": null,
            "expectedEnd": null,
            "endedOn": null,
            "price": 15000,
            "author": {
                "id": 4231,
                "wmcId": null,
                "first_name": "Diana",
                "last_name": "Yanez, CFP\u00ae",
                "firstName": "Diana",
                "lastName": "Yanez, CFP\u00ae",
                "phone": null,
                "email": "diana@allthecolors.net",
                "photo": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1654094101/njcy3eh4lmf52pugdz2v.jpg"
            },
            "ceCredits": 1,
            "industry": null,
            "designationInsitution": null,
            "lectures": [],
            "courses": []
        }
    ]
//     [
//     {
//         "id": 65,
//         "title": "Achieve Financial Wellness",
//         "description": "<p>The Willow Financial Wellness program is here to support you at each step of your financial life journey. Workshops and individual financial counseling performed by certified staff provide important guidance on money management matters.</p>",
//         "imageUrl": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1635607046/image_1_muc4zo.png",
//         "isActive": true,
//         "numberOfLectures": 1,
//         "startsOn": "2021-10-11T14:00:00+00:00",
//         "endedOn": null,
//         "author": {
//             "id": 12,
//             "first_name": "Mark",
//             "last_name": "Advisor"
//         },
//         "ceCredits": 1,
//         "isAssetManagement": true,
//         "isPromotionalProgram": false,
//         "industry": "Sample industry",
//         "designationInsitution": {
//             "name": "Boston Approval Group",
//             "states": [
//                 "AZ",
//                 "CA",
//                 "CO",
//                 "DC",
//                 "MA",
//                 "NJ",
//                 "NY"
//             ]
//         },
//         "lectures": [],
//         "courses": []
//     },
//     {
//         "id": 62,
//         "title": "Supporting Divorcing Clients",
//         "description": "Financial stability is a top concern among women who divorce. Divorce is an extremely turbulent, stressful and emotional process ... and one during which women must make many important financial decisions that will, for better or worse, impact the rest of their lives, including the division of assets and debt, the marital home, tax liabilities, alimony, etc. Thinking financially is not always easy. But, it is possible, especially if you have some help.",
//         "imageUrl": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1635689177/image_2_fahgfd.png",
//         "isActive": true,
//         "numberOfLectures": 2,
//         "startsOn": "2021-11-25T14:00:00+00:00",
//         "endedOn": null,
//         "author": {
//             "id": 12,
//             "first_name": "Mark",
//             "last_name": "Advisor"
//         },
//         "ceCredits": 1,
//         "isAssetManagement": true,
//         "isPromotionalProgram": false,
//         "industry": "Sample industry",
//         "designationInsitution": {
//             "name": "Boston Approval Group",
//             "states": [
//                 "AZ",
//                 "CA",
//                 "CO",
//                 "DC",
//                 "MA",
//                 "NJ",
//                 "NY"
//             ]
//         },
//         "lectures": [],
//         "courses": [
//             {
//                 "course": {
//                     "id": 2,
//                     "createdOn": "2022-02-11T16:39:41.909636+00:00",
//                     "title": "course 2",
//                     "description": "course 2",
//                     "externalAuthor": {
//                         "lastName": "Willow",
//                         "firstName": "Willow",
//                         "additionalInformation": {}
//                     },
//                     "imageUrl": "",
//                     "isActive": true,
//                     "isReadingMaterial": false,
//                     "isGoal": false,
//                     "isQuiz": false,
//                     "isVideo": true,
//                     "isPracticeSelfServe": false,
//                     "ceCredits": null,
//                     "documents": [],
//                     "documentTitle": null,
//                     "documentUrl": null,
//                     "programIdCFP": null,
//                     "programIdCIMA": null
//                 }
//             },
//             {
//                 "course": {
//                     "id": 3,
//                     "createdOn": "2022-08-25T13:40:55.210240+00:00",
//                     "title": "test",
//                     "description": "123",
//                     "externalAuthor": {
//                         "lastName": "Willow",
//                         "firstName": "Willow",
//                         "additionalInformation": {}
//                     },
//                     "imageUrl": "",
//                     "isActive": true,
//                     "isReadingMaterial": false,
//                     "isGoal": false,
//                     "isQuiz": true,
//                     "isVideo": false,
//                     "isPracticeSelfServe": false,
//                     "ceCredits": 12,
//                     "documents": [],
//                     "documentTitle": null,
//                     "documentUrl": null,
//                     "programIdCFP": "",
//                     "programIdCIMA": ""
//                 }
//             }
//         ]
//     },
//     {
//         "id": 6,
//         "title": "Supporting Grieving Clients",
//         "description": "Welcome to the Grief and Loss Journey. This program is geared towards helping you get access to support, resources and understand the multiple facets of grief, both emotional and practical.",
//         "imageUrl": "https://picsum.photos/id/340/500/500",
//         "isActive": true,
//         "numberOfLectures": 2,
//         "startsOn": "2021-11-25T14:00:00+00:00",
//         "endedOn": null,
//         "author": {
//             "id": 12,
//             "first_name": "Mark",
//             "last_name": "Advisor"
//         },
//         "ceCredits": 1,
//         "isAssetManagement": true,
//         "isPromotionalProgram": false,
//         "industry": "Sample industry",
//         "designationInsitution": {
//             "name": "Boston Approval Group",
//             "states": [
//                 "AZ",
//                 "CA",
//                 "CO",
//                 "DC",
//                 "MA",
//                 "NJ",
//                 "NY"
//             ]
//         },
//         "lectures": [],
//         "courses": [
//             {
//                 "course": {
//                     "id": 2,
//                     "createdOn": "2022-02-11T16:39:41.909636+00:00",
//                     "title": "course 2",
//                     "description": "course 2",
//                     "externalAuthor": {
//                         "lastName": "Willow",
//                         "firstName": "Willow",
//                         "additionalInformation": {}
//                     },
//                     "imageUrl": "",
//                     "isActive": true,
//                     "isReadingMaterial": false,
//                     "isGoal": false,
//                     "isQuiz": true,
//                     "isVideo": false,
//                     "isPracticeSelfServe": false,
//                     "ceCredits": null,
//                     "documents": [],
//                     "documentTitle": null,
//                     "documentUrl": null,
//                     "programIdCFP": null,
//                     "programIdCIMA": null
//                 }
//             },
//             {
//                 "course": {
//                     "id": 3,
//                     "createdOn": "2022-08-25T13:40:55.210240+00:00",
//                     "title": "test",
//                     "description": "123",
//                     "externalAuthor": {
//                         "lastName": "Willow",
//                         "firstName": "Willow",
//                         "additionalInformation": {}
//                     },
//                     "imageUrl": "",
//                     "isActive": true,
//                     "isReadingMaterial": false,
//                     "isGoal": false,
//                     "isQuiz": false,
//                     "isVideo": false,
//                     "isPracticeSelfServe": false,
//                     "ceCredits": 12,
//                     "documents": [],
//                     "documentTitle": null,
//                     "documentUrl": null,
//                     "programIdCFP": "",
//                     "programIdCIMA": ""
//                 }
//             }
//         ]
//     },
//     // {
//     //     "id": 5,
//     //     "title": "Custom program title 3",
//     //     "description": "Custom program description",
//     //     "imageUrl": "https://picsum.photos/seed/3/400/300",
//     //     "isActive": true,
//     //     "numberOfLectures": 2,
//     //     "startsOn": "2021-11-25T14:00:00+00:00",
//     //     "endedOn": null,
//     //     "author": {
//     //         "id": 12,
//     //         "first_name": "Mark",
//     //         "last_name": "Advisor"
//     //     }
//     // },
//     // {
//     //     "id": 5,
//     //     "title": "Custom program title 4",
//     //     "description": "Custom program description",
//     //     "imageUrl": "https://picsum.photos/seed/4/400/300",
//     //     "isActive": true,
//     //     "numberOfLectures": 2,
//     //     "startsOn": "2021-11-25T14:00:00+00:00",
//     //     "endedOn": null,
//     //     "author": {
//     //         "id": 12,
//     //         "first_name": "Mark",
//     //         "last_name": "Advisor"
//     //     }
//     // }
// ];

export const devGroupProgramDetails = {
    // "id": 5,
    // "title": "Custom program title",
    // "description": "<p>Led by Rana Chudnofsky, the Director of the The PART (Positivity and Relaxation Training) Program, the program was developed at the Benson-Henry Institute for Mind Body Medicine at Massachusetts General Hospital and is based on the Benson-Henry Institute&rsquo;s copyrighted Stress Management and Resiliency Training.</p>\n" +
    //     "<p><br /></p>\n" +
    //     "<p>The 9-week Positivity and Relaxation Training (PART) program helps participants develop a self-care routine to help manage stress, improve their outlook and enhance their quality of life. The program teaches participants a variety of mind body practices and self-care interventions, including:</p>\n" +
    //     "<br />\n" +
    //     "<ul>\n" +
    //     "    <li>How to recognize their personal responses to stress</li>\n" +
    //     "    <li>Meditative techniques that elicit the relaxation response</li>\n" +
    //     "    <li>How to change thought patterns and emotional outlook to adaptive and positive perspectives</li>\n" +
    //     "    <li>Techniques to improve sleep, eating and physical activity</li>\n" +
    //     "    <li>Ways to harness creativity, humor and appreciations to cultivate positivity and personal wellbeing</li>\n" +
    //     "</ul>\n" +
    //     "<p><br /></p>\n" +
    //     "<p>The program includes a manual and also a 1:1 coaching session with Rana Chudnofsky, MEd, the Director of the The PART Program.</p>",
    // "imageUrl": "https://picsum.photos/300/300",
    // "isActive": true,
    // "isAssetManagement":true,
    // "isPromotionalProgram":true,
    // "numberOfLectures": 2,
    // "startsOn": null,
    // "endedOn": null,
    // "expectedEnd":null,
    // "author": {
    //     "id": 12,
    //     "first_name": "Mark",
    //     "last_name": "Advisor"
    // },
    // "numberOfSubscriptions": 2,
    // "lectures": [
    //     {
    //         "id": 14,
    //         "title": "Investing webinar",
    //         "description": "Learn how to invest into this crazy worlsd",
    //         "coverPhoto": null,
    //         "ticketCost": 0,
    //         "announcementVideoUrl": null,
    //         "isActive": true,
    //         "isOnlyForClients": false,
    //         "purchaseLimitNumber": 50,
    //         "flashSaleStartDateTime": "2021-11-25T14:00:00+00:00",
    //         "flashSaleEndDateTime": "2021-11-25T15:00:00+00:00",
    //         "flashSaleStartedOn": null,
    //         "flashSaleEndedOn": null,
    //         "registrationCount": 2,
    //         "courses": [],
    //         "type":"group_session",
    //     },
    //     {
    //         "id": 15,
    //         "title": "Introduction",
    //         "description": "Introduction to financial tools that you have at your disposal.\r\nYou will learn how to earn, save, manage and invest your money.",
    //         "coverPhoto": "https://res.cloudinary.com/blz-lilyriche/image/upload/v1635607046/image_1_muc4zo.png",
    //         "ticketCost": 0,
    //         "announcementVideoUrl": null,
    //         "isActive": true,
    //         "isOnlyForClients": false,
    //         "purchaseLimitNumber": 50,
    //         "flashSaleStartDateTime": "2021-11-02T14:00:00+00:00",
    //         "flashSaleEndDateTime": "2021-11-02T15:00:00+00:00",
    //         "flashSaleStartedOn": null,
    //         "flashSaleEndedOn": null,
    //         "registrationCount": 2,
    //         "courses": [
    //             {
    //                 "id": 4,
    //                 "createdOn": "2021-09-13T15:38:14.051678+00:00",
    //                 "title": "title2",
    //                 "description": "description",
    //                 "imageUrl": "https://picsum.photos/200/300",
    //                 "isActive": true,
    //                 "isReadingMaterial": false,
    //                 "isGoal": false,
    //                 "isVideo": false
    //             },
    //             {
    //                 "id": 9,
    //                 "createdOn": "2021-09-27T15:48:42.716134+00:00",
    //                 "title": "test123",
    //                 "description": "test123",
    //                 "imageUrl": "https://picsum.photos/200/300",
    //                 "isActive": true,
    //                 "isReadingMaterial": false,
    //                 "isGoal": false,
    //                 "isVideo": false
    //             }
    //         ],
    //         "type":"group_session",
    //     }
    // ],
    // "price": 15000
    "id":62,
    "title":"Sensitive Client Situations",
    "description":"Test description here",
    "imageUrl":"https://res.cloudinary.com/blz-lilyriche/image/upload/v1649432704/vtnqunbeex2ffmtcrbo9.png",
    "isActive":true,
    "isAssetManagement":true,
    "isPromotionalProgram":true,
    "numberOfLectures":1,
    "startsOn":null,
    "expectedEnd":null,
    "endedOn":null,
    "price":0,
    "author":{
        "id":40,
        "first_name":"Candice",
        "last_name":"McGarvey",
        "photo": images.devDataCoachMichelleAvatar,
        "expertCategories": [
            {
                "categoryId": 1,
                "categoryName": "Willow Financial Coach"
            },
            {
                "categoryId": 11,
                "categoryName": "Divorce Coach"
            }
        ]
    },
    "numberOfSubscriptions":0,
    "lectures":[
        {
            "id":266,
            "title":"Sensitive Client Situations",
            "description":"Test description",
            "coverPhoto":"https://res.cloudinary.com/blz-lilyriche/image/upload/v1649432704/o4olrakkkfu21yxnyvha.png",
            "ticketCost":0,
            "announcementVideoUrl":null,
            "isActive":true,
            "isOnlyForClients":false,
            "purchaseLimitNumber":50,
            "flashSaleStartDateTime":null,
            "flashSaleEndDateTime":null,
            "flashSaleStartedOn":null,
            "flashSaleEndedOn":null,
            "type":"group_session",
            "registrationCount":0,
            "courses":[

            ]
        }
    ],
    "ceCredits": 1
};

export const devRegistrationDetails = {
    "registrationId": 12,
    "groupProgramId": 5,
    "registeredOn": "2021-11-25T14:00:00+00:00"
};

/*
        "id":4,
      "title":"Achieving Financial Wellness",
      "description":"The Willow Financial Wellness program is here to support you at each step of your financial life journey. Workshops and individual financial counseling performed by certified staff provide important guidance on money management matters.",
      "imageUrl":"https://res.cloudinary.com/blz-lilyriche/image/upload/q_60/v1635607046/image_1_muc4zo.jpg",
      "isActive":true,
      "numberOfLectures":0,
      "startsOn":"2021-12-01T18:00:00+00:00",
      "endedOn":null,
      "author":{
         "id":40,
         "first_name":"Candice",
         "last_name":"McGarvey"
      },
      "lectures":[
         {
            "videoCallId":"206accf1-0931-45a3-b20d-9b45afc3fa5e",
            "videoUrl":"https://live.trustwillow.com/livestream/206accf1-0931-45a3-b20d-9b45afc3fa5e",
            "registeredOn":"2021-12-01T00:46:26.712960+00:00",
            "webinar":{
               "id":178,
               "title":"Smart Spending and Credit and Debt",
               "description":" ",
               "coverPhoto":"https://res.cloudinary.com/blz-lilyriche/image/upload/q_60/v1635607046/image_1_muc4zo.jpg",
               "ticketCost":0,
               "announcementVideoUrl":null,
               "isActive":true,
               "isOnlyForClients":false,
               "purchaseLimitNumber":50,
               "flashSaleStartDateTime":"2021-12-08T18:00:00+00:00",
               "flashSaleEndDateTime":"2021-12-08T19:00:00+00:00",
               "flashSaleStartedOn":null,
               "flashSaleEndedOn":null
            },
            "courses":[

            ]
         },
         {
            "videoCallId":"bc3c0f8f-6a0c-4891-94d8-bee4f5b74af1",
            "videoUrl":"https://live.trustwillow.com/livestream/bc3c0f8f-6a0c-4891-94d8-bee4f5b74af1",
            "registeredOn":"2021-12-01T00:46:27.830697+00:00",
            "webinar":{
               "id":177,
               "title":"Achieving Financial Wellness",
               "description":" ",
               "coverPhoto":"https://res.cloudinary.com/blz-lilyriche/image/upload/q_60/v1635607046/image_1_muc4zo.jpg",
               "ticketCost":0,
               "announcementVideoUrl":null,
               "isActive":true,
               "isOnlyForClients":false,
               "purchaseLimitNumber":50,
               "flashSaleStartDateTime":"2021-12-15T18:00:00+00:00",
               "flashSaleEndDateTime":"2021-12-15T19:00:00+00:00",
               "flashSaleStartedOn":null,
               "flashSaleEndedOn":null
            },
            "courses":[

            ]
         },
         {
            "videoCallId":"94704359-5602-4fde-b227-e01502425b8c",
            "videoUrl":"https://live.trustwillow.com/livestream/94704359-5602-4fde-b227-e01502425b8c",
            "registeredOn":"2021-12-01T00:46:27.836222+00:00",
            "webinar":{
               "id":179,
               "title":"My Definition of Wealth and Cash Cushion",
               "description":" ",
               "coverPhoto":"https://res.cloudinary.com/blz-lilyriche/image/upload/q_60/v1635607046/image_1_muc4zo.jpg",
               "ticketCost":0,
               "announcementVideoUrl":null,
               "isActive":true,
               "isOnlyForClients":false,
               "purchaseLimitNumber":50,
               "flashSaleStartDateTime":"2021-12-01T18:00:00+00:00",
               "flashSaleEndDateTime":"2021-12-01T19:00:00+00:00",
               "flashSaleStartedOn":null,
               "flashSaleEndedOn":null
            },
            "courses":[

            ]
         }
      ]
   }
*/